import { useState } from "react";
import MarkdownCard from "../components/MarkdownCard";
import { Box, Typography, useTheme, Button, useMediaQuery } from "@mui/material";
import { tokens } from "../theme";
import FileUpload from "../components/FileUpload";
import { uploadFitFile } from "../api/client";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { clearParametersCache } from "../services/userParametersService";

const Dashboard = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleFileUpload = async (file, params) => {
    setLoading(true);
    try {
      const response = await uploadFitFile(file, params);

      // Clear parameters cache so next load fetches updated values from backend
      clearParametersCache();
      console.log('Parameters cache cleared after upload');

      // Navigate to analysis page with the data, file, and reusedFileId for reanalysis
      navigate('/analysis', { state: { workoutData: response, file: file, reusedFileId: params.reusedFileId } });
    } catch (error) {
      console.error('Upload error:', error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box m={isMobile ? "10px" : "20px"} display="flex" justifyContent="center" sx={{ overflowX: 'hidden' }}>
      <Box maxWidth="1200px" width="100%">
        {/* Welcome and Quick Start Cards */}
        <MarkdownCard file="welcome.md" />

        <Box mb={4} display="flex" flexDirection={isMobile ? 'column' : 'row'} alignItems={isMobile ? 'flex-start' : 'center'} justifyContent="space-between">
          <Box>
            <Typography
              variant="h2"
              fontWeight="bold"
              color={colors.grey[100]}
              mb={1}
            >
              {t('dashboardTitle', 'Biking Analysis')}
            </Typography>
            <Typography variant="h5" color={colors.grey[300]}>
              {t('dashboardSubtitle', 'Upload your cycling workout FIT file to analyze performance')}
            </Typography>
          </Box>
          <Button
            variant="contained"
            onClick={() => navigate('/running')}
            sx={{ whiteSpace: 'nowrap', mt: isMobile ? 2 : 0, ml: isMobile ? 0 : 2, backgroundColor: colors.blueAccent[600], '&:hover': { backgroundColor: colors.blueAccent[500] } }}
          >
            {t('switchToRunning', 'Switch to Running →')}
          </Button>
        </Box>

        <FileUpload 
          onFileUpload={handleFileUpload}
          loading={loading} 
        />

      </Box>
    </Box>
  );
};

export default Dashboard;
